<template>
  <div class="wrap">
    <div class="left-wrap">
      <div class="">問　<span v-if="question.choice5 != ''">-{{ question.choice5 }}-</span></div>
      <p :class="'pi-'+question.id" v-html="question.question1"></p>
      <ol class="Ar2jysLB">
      <li v-for="n in 4" :key="n">
        <div v-if="question['choice' + String(n)] && question['choice' + String(n)] != ''">
          <label class="d-flex align-items-start">
            <div class="Ki9LFtxd" v-html="question['choice' + String(n)]"></div>
          </label>
        </div>
      </li>
    </ol>
    </div>
    <div class="center-border"></div>
    <div class="right-wrap ">
      <div class="mb-3 d-flex align-items-center"><input type="checkbox" v-model="questions[index].isBookmarkArr[0]" @click="bookmark(0)" class="G6zckbvr " :class="{'eJ7LMsiQ': questions[index].isBookmarkArr[0]}">問{{question.no}}</div>
    <ol class="Ar2jysLB" :class="{'Gm8W5aZb': questions[index].isBookmarkArr[0]}">
      <li v-for="n in 4" :key="n">
        <div>
          <label class="d-flex align-items-start">
            <input class="" type="radio" name="select" @change="answer(n)" :checked="question['currentChoice'] == n">
          </label>
        </div>
      </li>
    </ol>
      <div style="height: 250px;"></div>
    </div>


  </div>
</template>


<script lang="ts">
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Question from "../../models/question";
import StorageService from "../../services/storage";
import question from "@/services/question";
@Component({
  components: {}
})
export default class Double2 extends Vue {
  @Prop()
  private question!: Question;
  @Prop()
  private index!: number;
  @Prop()
  private indexs!: number[];
  @Prop()
  public questions!: Question[]

  private isLock: boolean = false;

  created() {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
  }

  mounted() {
   }


  @Emit("answerEmit")
  answerEmit() {
    return
  }

  private bookmark(index: number) {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
    if (this.questions[this.index].isBookmarkArr[index] == undefined) this.questions[this.index].isBookmarkArr[index] = false
    this.questions[this.index].isBookmarkArr[index] = !this.questions[this.index].isBookmarkArr[index];

    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }

  public async answer(i: number) {
    this.questions[this.index].result = this.question.answer  == String(i);
    this.questions[this.index].currentChoice = i;
    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }
}
</script>

<style scoped>
.wrap {
  margin: -1.5em !important;
  height: calc(100vh - 120px - 90px);
  display: flex;
  align-items: stretch;

}

.right-wrap {
  width: calc(30% - 1px);
  padding: 3em;
  padding-left: 1.75em;
  padding-right: 1em;
  overflow-y: scroll;
}

.center-border {
  width: 2px;
  background-color: #ccc;
  height: 100%;
}

.left-wrap {
  width: calc(70% - 1px);
  padding: 1.5em;
  overflow-y: scroll;
}


</style>
<style>
.left-wrap img {
  width: 100% ;
}
</style>